module.exports = __webpack_public_path__ + "img/ic_teacher_xiezuo.1ac4a793.jpg";